import { useEffect, useRef } from "react";
import InfoPersoStep2Bloc from "../blocs/info-perso/InfoPersoStep2Bloc";
import { isMobile, scroll2Top } from "../utils/utils";
import GeneralDataProtectionBloc from "../blocs/common/GeneralDataProtectionBloc";

export default function InfoPersoStep2Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
   
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Complétez votre adresse</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep2Bloc/>
        </div>
          <GeneralDataProtectionBloc/>
      </div>
    
    )

}